export const onEnter = (cb: () => void) => {
    return (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') cb()
    }
}